import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

const defaultDescription = [
  'The aim of the WILDMEAT database is to ensure that efforts to sustainably ',
  'govern and manage wild meat resources are based on the best available ',
  'evidence, by providing open access to all currently available data on ',
  'wildmeat hunting offtakes, consumption and sales.',
].join('');

export default function MapPageHelmet () {
  const params = useParams();
  const location = useLocation();
  const { studyDetailData } = useSelector(s => s.studyDetail);
  const { sbBlock } = useSelector(s => s.sb);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isHomePage, setIsHomePage] = useState(false);

  const singleID = studyDetailData?.studyId || '';

  const getPageMetadata = async ({ slugType, slug }) => {
    try {
      const { data } = await axios.get(`/map/slug/${slugType}/${slug}`);
      setTitle(data.pageTitle);
      setDescription(data.pageDescription);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (studyDetailData && parseInt(params.id) === studyDetailData.studyId) {
      setTitle(studyDetailData.title);
      setDescription(studyDetailData.description);
      setIsHomePage(false);
    } else {
      if (sbBlock === 'init') {
        setTitle(null);
        setDescription(defaultDescription);
        setIsHomePage(true);
      } else {
        setIsHomePage(false);

        if (sbBlock === 'Species') {
          if (location.pathname === '/species') {
            setTitle(null);
            setDescription('List of available species');
          } else {
            if (params.scientificNameSlug) {
              getPageMetadata({
                slugType: 'species',
                slug: params.scientificNameSlug
              });
            }
          }
        }

        if (sbBlock === 'Countries') {
          if (location.pathname === '/countries') {
            setTitle(null);
            setDescription('List of available countries');
          } else {
            if (params.countrySlug) {
              getPageMetadata({
                slugType: 'countries',
                slug: params.countrySlug
              });
            }
          }
        }

        if (sbBlock === 'References') {
          if (location.pathname === '/references') {
            setTitle(null);
            setDescription('List of available publications (references)');
          } else {
            if (params.referenceId) {
              getPageMetadata({
                slugType: 'references',
                slug: params.referenceId
              });
            }
          }
        }
      }
    }
  }, [
    params,
    location,
    sbBlock,
    studyDetailData
  ]);

  const pageTitle =
    `${
      singleID
        ? (
            `WILDMEAT Database Explorer ${
              singleID ? ` | Study #${singleID} | ${title}` : ''
            }`
          )
        : (
            title
              ? title
              : (
                  sbBlock !== 'init'
                    ? `WILDMEAT Database Explorer | ${sbBlock}`
                    : 'WILDMEAT Database Explorer'
                )
          )
    }`
  ;

  const pageDescription = isHomePage
    ? defaultDescription
    : description;

  const pageType = isHomePage ? 'website' : 'article';

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name='description' content={pageDescription} />
      <meta property="og:type" content={pageType} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta name="twitter:creator" content="@reggarantai" />
      <meta name="twitter:card" content={pageType} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
    </Helmet>
  );
}
